import { FC } from 'react';
import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
} from '@mui/material';

interface ToggleGroupProps
  extends Omit<ToggleButtonGroupProps, 'children' | 'color'> {
  options: { label: string; value: string }[];
}

const ToggleGroup: FC<ToggleGroupProps> = ({ options, ...rest }) => {
  return (
    <ToggleButtonGroup {...rest} color="primary" exclusive>
      (
      {options.map((option) => (
        <ToggleButton value={option.value}>{option.label}</ToggleButton>
      ))}
      )
    </ToggleButtonGroup>
  );
};

export default ToggleGroup;
